import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useResponsive } from '../../hooks/use-responsive';
import { NAV, HEADER } from './config-layout';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }) {
  const lgUp = useResponsive('up', 'lg');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: `calc(100vh - ${HEADER.H_MOBILE + SPACING + 65}px)`, // 👈 reserve screen space
        display: 'flex',
        flexDirection: 'column',
        pt: `${HEADER.H_MOBILE + SPACING}px`,
        ...(lgUp && {
          px: 2,
          pt: `${HEADER.H_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.WIDTH}px)`,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
